// extracted by mini-css-extract-plugin
module.exports = {"Container":"BlogArticle_Container__31SZe","ArticleBox":"BlogArticle_ArticleBox__3O0PS","Partners":"BlogArticle_Partners__3a4XN"};